/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './editGroup.defs.js'
export { main as default } from './editGroup.defs.js'
